module.exports = __webpack_public_path__ + "img/news17_1.281d43f7.jpg";